import { Highlight, HighlightingState } from "./types";

export const getActiveSelection = ({
  highlighting,
}: {
  highlighting: HighlightingState;
}): Highlight | null =>
  highlighting.selections.find((sel) => !sel.id) ||
  highlighting.selections.find(
    (sel) => sel.id === highlighting.activeSelectionId,
  ) ||
  null;

export const getSelections = ({
  highlighting,
}: {
  highlighting: HighlightingState;
}): Highlight[] => highlighting.selections || [];

export const sortByTime = (selections: Highlight[]): Highlight[] =>
  selections.sort(
    (a, b) =>
      new Date(String(a.updatedAt || new Date())).getTime() -
      new Date(String(b.updatedAt || new Date())).getTime(),
  );

export const getIntersections = (
  state: { highlighting: HighlightingState },
  selection: Highlight,
): Highlight[] =>
  getSelections(state).filter(
    (v: Highlight) =>
      ((v.start.sequence <= selection.start.sequence &&
        v.end.sequence >= selection.start.sequence) ||
        (v.start.sequence <= selection.end.sequence &&
          v.end.sequence >= selection.end.sequence)) &&
      v.id !== selection.id &&
      v.id,
  );
